'use strict';

import _ from 'lodash';

import './PaymentPlans.less';

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { PromoPropType } from 'ck-core-client/source/classes/Promo';
import productMeta from 'ck-core/source/data/productMeta';
import subscriptionPlans from 'ck-core/source/collections/subscriptionPlans';
import CouponPropType from './CouponPropType';
import CurrencyPropType from './CurrencyPropType';
import CouponRemainingUses from './CouponRemainingUses';
import WithCurrency from './WithCurrency';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import VisibilitySensor from 'react-visibility-sensor';
import lang from './PaymentPlansLang';
import Assets from 'ck-core-client/source/system/Assets';
import PaymentPlan, { planIdPropType } from './PaymentPlan';
import trialCtaPlans from '../../data/trialCtaPlans';
import TrialPaymentPlan from './TrialPaymentPlan';
import { TabbedSelector } from 'ck-core-client/source/components/TabbedSelector';
import minecraftTabBackground from 'ck-website/graphics/backgrounds/button-minecraft.svg';
import { getPlanSizeName } from 'ck-core/source/data/PlanSize';
import robloxTabBackground from 'ck-website/graphics/backgrounds/button-roblox.svg';
import bundleTabBackground from 'ck-website/graphics/backgrounds/button-bundle.svg';
import familyTabBackground from 'ck-website/graphics/backgrounds/button-family.svg';
import Section from 'ck-core-client/source/components/Layout/Section';
import QandACard from 'ck-core-client/source/components/QandACard';
import coolmathFaqLang from 'ck-core-client/source/ui/components/FaqBase/CoolMathCheckoutFaqLang.js';
import faqLang from 'ck-core-client/source/ui/components/FaqBase/CheckoutFaqLang.js';

import { ConnectedPaymentPlanRow } from 'ck-website/source/components/PaymentPlanRow';
import { TabTheme } from 'ck-core-client/source/components/TabbedSelector/Tab';

import products from 'ck-core/source/data/products';
import planSizes from 'ck-core/source/data/planSizes';
import MinecraftEditionSupportSummary from '../system/MinecraftEditionSupportSummary';
import PlansAdditionalInfo from '../system/PlansAdditionalInfo';

import { requiredBy } from 'airbnb-prop-types';
import {
	ADWORDS_CONVERSION_LABEL,
	trackAdwordsConversion
} from 'ck-core-client/source/trackers/Adwords';
import { FACEBOOK_CUSTOM_EVENT, trackFacebookPixel } from 'ck-core-client/source/trackers/Facebook';
import { trackAnalytic } from 'ck-core-client/source/trackers/Analytic';
import { PRODUCT_ID } from 'ck-core/source/data/Product';

class PaymentPlans extends React.Component {
	renderProductTabs() {
		const isDisabled = product => !!_.get(this.props.disabledProductTabs, product);

		const choices = [
			{
				id: products.MINECRAFT,
				title: 'Minecraft',
				colour: 'green',
				background: minecraftTabBackground
			},
			{
				id: products.ROBLOX,
				title: 'Roblox',
				colour: 'red',
				background: robloxTabBackground
			},
			{
				id: products.BUNDLE,
				title: 'Bundle',
				colour: 'orange',
				background: bundleTabBackground
			}
		];

		for (let choice of choices) {
			choice.disabled = isDisabled(choice.id);
		}

		return (
			<div className="PaymentPlans__ProductTabsWrapper">
				<TabbedSelector
					tabs={choices}
					theme={TabTheme.FORMAL}
					handleClick={this.props.handleSelectProduct || _.noop}
					initialId={this.props.activeProductTab}
				/>
			</div>
		);
	}

	renderSizeTabs() {
		const isDisabled = size => !!_.get(this.props.disabledSizeTabs, size);

		const choices = [
			{
				id: planSizes.INDIVIDUAL,
				title: getPlanSizeName(planSizes.INDIVIDUAL),
				colour: 'blue',
				background: familyTabBackground
			},
			{
				id: planSizes.FAMILY,
				title: getPlanSizeName(planSizes.FAMILY),
				colour: 'blue',
				background: familyTabBackground
			}
		];

		for (let choice of choices) {
			choice.disabled = isDisabled(choice.id);
		}
		return (
			<div className={`PaymentPlans__SizeTabsWrapper PaymentPlans__SizeTabsWrapper--purple`}>
				{/* <div className="PaymentPlans__SizeTabsWrapper__header">Choose your account type</div> */}
				<TabbedSelector
					tabs={choices}
					theme={TabTheme.FORMAL}
					handleClick={this.props.handleSelectSize || _.noop}
					initialId={this.props.activeSizeTab}
				/>
				<div className="PaymentPlans__SizeTabsWrapper__info">
					Family plans include access for 5 separate accounts
				</div>
			</div>
		);
	}

	render() {
		const {
			promo,
			coupon,
			handleSelectPlan,
			planIds,
			currency,
			activeProductTab,
			showSizeTabs,
			showProductTabs,
			highlightedPlan,
			isOnCheckoutPage,
			inlineCheckoutStages
		} = this.props;

		const usePlanRows = false;
		/*
			TODO CORE-4282
			CK.fn.inTest('PlanRows');
		*/

		let doNotTrackViewPlans = true;
		let plansHaveAnimated = false;

		setTimeout(() => {
			doNotTrackViewPlans = false;
		}, 2000);

		const trackingAction = _.once(() => {
			trackAnalytic('ViewPlans');
			trackFacebookPixel(FACEBOOK_CUSTOM_EVENT.VIEW_PLANS);
			trackAdwordsConversion(ADWORDS_CONVERSION_LABEL.VIEW_PLANS);
		});

		const trackViewPlans = () => {
			if (!doNotTrackViewPlans || isOnCheckoutPage) {
				trackingAction();

				if (!plansHaveAnimated) {
					plansHaveAnimated = true;

					// let isTrialPlanDisplayed = document.getElementById('plan-trial');

					// if (isTrialPlanDisplayed) {
					// 	document.getElementById('plan-trial').parentNode.style.visibility = 'hidden';
					// }

					// document.getElementById(
					// 	'plan-ck-v4-modding-monthly-recurring'
					// ).parentNode.style.visibility = 'hidden';
					// document.getElementById('plan-ck-v4-modding-annually').parentNode.style.visibility =
					// 	'hidden';
					// document.getElementById('plan-ck-v4-modding-lifetime').parentNode.style.visibility =
					// 	'hidden';

					// setTimeout(() => {
					// 	if (isTrialPlanDisplayed) {
					// 		document.getElementById('plan-trial').parentNode.style.visibility = 'visible';
					// 		document.getElementById('plan-trial').parentNode.className += ' animated bounceIn';
					// 	}

					// 	document.getElementById(
					// 		'plan-ck-v4-modding-monthly-recurring'
					// 	).parentNode.style.visibility = 'visible';
					// 	document.getElementById('plan-ck-v4-modding-monthly-recurring').parentNode.className +=
					// 		' animated bounceIn';
					// }, 800);

					// setTimeout(() => {
					// 	document.getElementById('plan-ck-v4-modding-annually').parentNode.style.visibility =
					// 		'visible';
					// 	document.getElementById('plan-ck-v4-modding-annually').parentNode.className +=
					// 		' animated bounceIn';
					// }, 1100);

					// setTimeout(() => {
					// 	document.getElementById('plan-ck-v4-modding-lifetime').parentNode.style.visibility =
					// 		'visible';
					// 	document.getElementById('plan-ck-v4-modding-lifetime').parentNode.className +=
					// 		' animated bounceIn';
					// }, 1400);
				}
			}
		};

		const showPromoBackground = promo && CK.fn.isNonGenericPromo(promo);

		let promoClassName;

		if (promo) promoClassName = promo.id;

		const classes = classnames(
			'PaymentPlans',
			showPromoBackground && 'promo',
			promo,
			promoClassName
		);

		let promoLang = {},
			upgradeLang = {},
			style;

		let bottomBackground, topLeftImage, topRightImage;

		if (promo) {
			promoLang = promo.lang.plans;

			// if (CK.fn.userCurrency && CK.fn.userCurrency() == 'gbp') {
			// 	// GBP/ UK users to get different copy

			// 	promoLang = {
			// 		TITLE: "Don't miss our exclusive Christmas deals!",
			// 		SUBTITLE: 'Learn to code Minecraft & Roblox, for ages 8-14'
			// 	};
			// }

			if (showPromoBackground) {
				if (promo.id === 'summer') {
					const backgroundAssetTopLeftId = `promo-${promo.id}-plans-background`;
					const backgroundAssetTopRightId = Assets.get(`promo-${promo.id}-plans-background`);

					topLeftImage = (
						<div className="PaymentPlans__topLeftImagePromoSummer">
							<ReactCKImage name={backgroundAssetTopLeftId} />
						</div>
					);
					topRightImage = (
						<div
							className="PaymentPlans__topRightImagePromoSummer"
							style={{ backgroundImage: `url(${_.get(backgroundAssetTopRightId, 'url')})` }}
						/>
					);
					bottomBackground = <div></div>;
				} else if (promo.id === 'homeschooling') {
					// Not normal homeschooling which is blue, but generic with homeschooling assets

					topLeftImage = (
						<ReactCKImage
							name="payment-pipe-left"
							forceImgTag={true}
							extraClasses={['pipesLeft', 'img-responsive']}
						/>
					);
					topRightImage = (
						<ReactCKImage
							name="generic-blue-pipe-right"
							forceImgTag={true}
							extraClasses={['pipesRight', 'img-responsive']}
						/>
					);
					bottomBackground = <div></div>;
				} else {
					// Non summer sale bg

					const backgroundAssetTopLeftId = `promo-${promo.id}-plans-background-top-left`;
					const backgroundAssetTopRightId = `promo-${promo.id}-plans-background-top-right`;
					const backgroundAssetBottom = Assets.get(`promo-${promo.id}-plans-background-bottom`);

					topLeftImage = (
						<div className="PaymentPlans__topLeftImagePromo">
							<ReactCKImage name={backgroundAssetTopLeftId} />
						</div>
					);
					topRightImage = (
						<div className="PaymentPlans__topRightImagePromo">
							<ReactCKImage name={backgroundAssetTopRightId} />
						</div>
					);
					bottomBackground = (
						<div
							className="bottomBackground"
							style={{ backgroundImage: `url(${_.get(backgroundAssetBottom, 'url')})` }}
						/>
					);
				}
			}
		}

		const anyPlanIsAnUpgrade = _.some(planIds, planId => {
			if (trialCtaPlans[planId]) {
				return;
			}

			try {
				const planCursor = subscriptionPlans(planId);

				const priceInCurrency = planCursor.priceInCurrency(currency, {
					html: false,
					user: CK.user
				});

				return priceInCurrency.upgradeDiscount > 0;
			} catch (err) {
				CK.logger.warn(err);
			}
		});

		if (anyPlanIsAnUpgrade) {
			upgradeLang = lang.UPGRADE;
		}

		let minecraftEditionSupport = null;

		if (
			_.some(planIds, planId => {
				const plan = subscriptionPlans(planId);

				return _.includes([products.MINECRAFT, products.BUNDLE], plan.product());
			})
		) {
			minecraftEditionSupport = <MinecraftEditionSupportSummary />;
		}

		const backgrounds = {
			[PRODUCT_ID.MINECRAFT]: minecraftTabBackground,
			[PRODUCT_ID.ROBLOX]: robloxTabBackground,
			[PRODUCT_ID.BUNDLE]: bundleTabBackground
		};
		const colours = {
			[PRODUCT_ID.MINECRAFT]: 'darkGreen',
			[PRODUCT_ID.ROBLOX]: 'red',
			[PRODUCT_ID.BUNDLE]: 'yellow'
		};

		const plans = _.map(planIds, planId => {
			const translucent = highlightedPlan ? planId !== highlightedPlan : false;
			const trialCtaPlan = trialCtaPlans[planId];

			const baseProps = {
				planId,
				currency: currency,
				className: usePlanRows ? '' : `width${Math.round(100 / planIds.length)}`,
				background: backgrounds[activeProductTab],
				colour: colours[activeProductTab]
			};

			if (trialCtaPlan) {
				const product = subscriptionPlans(planIds[1]).product();

				return React.createElement(usePlanRows ? ConnectedPaymentPlanRow : TrialPaymentPlan, {
					key: planId,
					product: product,
					productName: productMeta[product].name,
					...baseProps,
					...trialCtaPlan,
					onClick: () => handleSelectPlan(planId)
				});
			}

			return React.createElement(usePlanRows ? ConnectedPaymentPlanRow : PaymentPlan, {
				key: planId,
				...baseProps,
				coupon,
				onClick: coupon => handleSelectPlan(planId, coupon),
				translucent: translucent,
				highlighted: highlightedPlan ? planId === highlightedPlan : false
			});
		});

		const wrapperClasses = classnames(
			'PaymentPlansWrapper',
			'PaymentPlansWrapper--' + this.background
		);
		const plansWrapperClasses = classnames(
			'PaymentPlans__plansWrapper',
			usePlanRows && 'PaymentPlans__plansWrapper--rows'
		);

		let checklist = [];

		lang.MEMBERSHIP.CHECKLIST.forEach(checklistLang => {
			checklist.push(
				<div className="checklistRow" key={checklistLang.NAME}>
					<div className="icon">
						<ReactCKImage name="tick-green" />
					</div>
					<div className="checklistItem"> {checklistLang.DESCRIPTION} </div>
				</div>
			);
		});

		let checkoutFaq = faqLang;

		if (CK.config.name === 'ck-coolmath') checkoutFaq = coolmathFaqLang;

		let isBlackFriday = true;

		if (promo && promo.id === 'blackfriday' && new Date() < new Date('2022-11-31'))
			isBlackFriday = true;

		let upgradeText =
			'Good news! As a current customer, we have discounted your previous purchases towards any available plans.';

		if (promo)
			upgradeText =
				'Good news! As a current customer, we have discounted your previous purchases towards any available plans. This is in addition to the sale price you see below. Upgrading will never cost more than purchasing as a new customer.';

		return (
			<div id="PlansIdWrapper" className={wrapperClasses}>
				<div className={classes} style={style}>
					{typeof window !== 'undefined' && <VisibilitySensor onChange={trackViewPlans} />}

					{topLeftImage}
					{topRightImage}
					{bottomBackground}

					<h2 className="title">{upgradeLang.TITLE || promoLang.TITLE || lang.TITLE}</h2>
					<h3 className="subtitle">
						{upgradeLang.SUBTITLE || promoLang.SUBTITLE || lang.SUBTITLE}
					</h3>

					<div className="packagesWrapper">
						{showProductTabs && this.renderProductTabs()}
						{showSizeTabs && this.renderSizeTabs()}

						{anyPlanIsAnUpgrade && <div className="upgradePricingMessage">{upgradeText}</div>}

						<div className={plansWrapperClasses}>{plans}</div>
						{!promo && coupon && coupon.maxUses() && <CouponRemainingUses coupon={coupon} />}

						{inlineCheckoutStages}

						<PlansAdditionalInfo />

						<div className="membershipSummary">
							<div
								className="background"
								style={{
									backgroundImage: `url(${_.get(Assets.get(`checkout-gift-promo-small`), 'url')})`
								}}
							/>

							<div className="textWrapper">
								<h3 className="header">{lang.MEMBERSHIP.TITLE}</h3>
								<div className="copy">{checklist}</div>
							</div>
						</div>
					</div>

					{isBlackFriday && (
						<div className="giftingInfo blackFridayMessage">
							<ReactCKImage
								name="checkout-home-promo"
								extraClasses={['img-responsive', 'promo-large']}
							/>
							<ReactCKImage
								name="checkout-gift-promo-small"
								extraClasses={['img-responsive', 'promo-small']}
							/>
							<div className="textWrapper">
								<div className="header">{lang.BLACKFRIDAY_PROMO.HEADER}</div>
								<div className="copy">{lang.BLACKFRIDAY_PROMO.COPY}</div>
							</div>
						</div>
					)}

					<div className="giftingInfo">
						<ReactCKImage
							name="checkout-gift-promo"
							extraClasses={['img-responsive', 'promo-large']}
						/>
						<ReactCKImage
							name="checkout-gift-promo-small"
							extraClasses={['img-responsive', 'promo-small']}
						/>

						<div className="textWrapper">
							<h3 className="header">{lang.GIFT.HEADER}</h3>
							<div className="copy">{lang.GIFT.COPY}</div>
						</div>
					</div>

					{minecraftEditionSupport}

					<div className="checkoutFaq">
						{checkoutFaq.QUESTIONS.map(section => {
							return (
								<div key={section.TITLE}>
									<h3 key={section.TITLE} className="faqTitle">
										{section.TITLE}
									</h3>
									{section.CARDS.map(question => {
										return (
											<QandACard
												key={question.QUESTION}
												question={question.QUESTION}
												answer={question.ANSWER}
											/>
										);
									})}
								</div>
							);
						})}
					</div>

					{!promo && (
						<ReactCKImage
							name="payment-pipe-left"
							forceImgTag={true}
							extraClasses={['pipesLeft', 'img-responsive']}
						/>
					)}
					{!promo && (
						<ReactCKImage
							name="generic-blue-pipe-right"
							forceImgTag={true}
							extraClasses={['pipesRight', 'img-responsive']}
						/>
					)}
				</div>
			</div>
		);
	}
}

PaymentPlans.planIdsPropType = PropTypes.arrayOf(planIdPropType);

PaymentPlans.defaultProps = {
	showProductTabs: false,
	background: 'white'
};

PaymentPlans.propTypes = {
	currency: CurrencyPropType.isRequired,
	planIds: PaymentPlans.planIdsPropType.isRequired,
	coupon: CouponPropType,
	handleSelectPlan: PropTypes.func.isRequired,
	isOnCheckoutPage: PropTypes.bool,
	promo: PromoPropType,
	background: PropTypes.string,
	inlineCheckoutStages: PropTypes.element,

	showProductTabs: PropTypes.bool,
	activeProductTab: requiredBy('showProductTabs', PropTypes.oneOf(_.values(products))),
	/*
		{
			product: Boolean
		}
	*/
	disabledProductTabs: requiredBy(
		'showProductTabs',
		PropTypes.shape(
			_.zipObject(
				_.values(products),
				_.times(_.values(products).length, _.constant(PropTypes.bool))
			)
		)
	),
	handleSelectProduct: requiredBy('showProductTabs', PropTypes.func),

	showSizeTabs: PropTypes.bool,
	activeSizeTab: requiredBy('showSizeTabs', PropTypes.oneOf(_.values(planSizes))),
	disabledSizeTabs: requiredBy(
		'showSizeTabs',
		PropTypes.shape(
			_.zipObject(
				_.values(planSizes),
				_.times(_.values(planSizes).length, _.constant(PropTypes.bool))
			)
		)
	),
	handleSelectSize: requiredBy('showSizeTabs', PropTypes.func),

	highlightedPlan: PropTypes.string
};

export const VanillaPaymentPlans = PaymentPlans;

export default WithCurrency(PaymentPlans);
